<template>
  <div id="search-form">
    <form @submit.prevent="search" class="container d-flex flex-column">
      <div class="row">
        <div class="block-wrapper col-md-3">
          <fieldset class="search">
            <legend>{{ $t('form.search.legend') }}</legend>
            <ncs-select field="ncs_documents.subcorpus" :allowEmpty="false" value="Learners"/>
            <ncs-multi-select v-show="learners" :disabled="!learners" name="ncs_documents.l1-learners"
                              field="ncs_documents.native_language" :dependencies="['ncs_documents.subcorpus']"/>
            <ncs-multi-select v-show="!learners" :disabled="learners" name="ncs_documents.l1-native"
                              field="ncs_documents.native_language" :dependencies="['ncs_documents.subcorpus']"/>
          </fieldset>
        </div>
        <div class="col-md-6">
          <fieldset class="element-section">
            <legend>
              <ncs-label id="elements.type.options.units-optional" style="font-size: 17px"/>
            </legend>
            <div class="units">
              <div class="left">
                <ncs-units-element side="left" :max-elements="5"/>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="block-wrapper col-md-3 mb-3">
          <fieldset class="result">
            <legend>{{ $t('form.result.legend') }}</legend>
            <ncs-page-size-selector/>
          </fieldset>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-3">
        <ncs-back-button/>
        <div class="btn-group align-self-end">
          <text-download-button/>
          <button type="submit" class="btn btn-primary">{{ $t('search') }}</button>
          <ncs-reset-button/>
        </div>
      </div>
    </form>
    <ncs-result>
      <navigation-result/>
      <task-result/>
      <ncs-kwic-result>
        <template slot="kwicHeader" slot-scope="{document}">
          <kwic-header :document="document"/>
        </template>
      </ncs-kwic-result>
      <ncs-context-result :textHeader="false">
        <template slot="documentHeader" slot-scope="{document}">
          <context-header :document="document"/>
        </template>
      </ncs-context-result>
    </ncs-result>
  </div>
</template>


<script>
  import get from 'lodash/get'
  import isEqual from 'lodash/isEqual'
  import KwicHeader from './KwicHeader'
  import ContextHeader from './ContextHeader'
  import NavigationResult from './NavigationResult'
  import TaskResult from './TaskResult'
  import NavigationDownloadButton from './NavigationDownloadButton'
  import TextDownloadButton from './TextDownloadButton'
  import {mapState, mapGetters} from 'vuex'

  export default {
    components: {
      KwicHeader,
      ContextHeader,
      NavigationResult,
      TaskResult,
      NavigationDownloadButton,
      TextDownloadButton
    },
    computed: {
      ...mapState({
        learners: s => get(s.filters.byId['ncs_documents.subcorpus'], 'value', 'Learners') === 'Learners',
        elements: s => s.elements.left
      }),
      ...mapGetters({resultType: 'api/formResultType'})
    },
    methods: {
      switchResultType() {
        const emptyElements = this.elements.length === 0 || this.elements.length === 1 && !this.elements[0].unit.value
        const kwicSelected = this.$store.state.api.resultType === 'kwic'
        if (kwicSelected && emptyElements) {
          // Switch to navigation if no elements
          this.$store.commit('api/setResultType', 'navigation')
          this.$store.commit('elements/setSearchType', {type: 'texts'})
        } else if (!kwicSelected && !emptyElements) {
          // Switch to kwic if there is some element.
          // Avoid clearing result when returning from context or metadata pagination.
          this.$store.commit('api/setResultType', 'kwic')
          const left = this.elements
          this.$store.commit('elements/setSearchType', {type: 'units'})
          // Elements are reset on search type change, restore them.
          this.$store.commit('elements/setElements', {left, right: []})
        }
        this.$store.dispatch('order/setDefault')
      },
      // Custom search button that switches result type if needed
      search() {
        this.switchResultType()
        this.$store.dispatch('pagination/changePage', 1)
        this.$ga.page(`/search/${this.resultType}`)
      }
    },
    watch: {
      learners() {
        this.$store.dispatch('api/reset')
        this.$store.dispatch('elements/reset')
      }
    }
  }
</script>
